import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enLocales from './locals/en.json';
import faLocales from './locals/fa.json';

// ----------------------------------------------------------------------
const resources = {
  en: { translations: enLocales },
  fa: { translations: faLocales },
};
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'fa',
    fallbackLng: ['fa', 'en'],
    keySeparator: false,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
